import BaseStore from "../base/BaseStore";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Service from "../model/service/Service";


class ObyPayStore extends BaseStore {
    private _service: Service
    
    constructor() {
        super();
        this._service = new Service()
    }

    public get service(): Service {
        return this._service;
    }

    setService(service: Service) {
        this._service = service
        this.emitChange()
    }
}

const storeAction = (store: ObyPayStore) => {
    return (action: any) => {
        switch (action.type) {
            case "SET_OBYPAY_SERVICE":
                store.setService(action.data);
                break;
        }
    }
}

const ObyPayStoreShared = new ObyPayStore()
ObyPayStoreShared.dispatchToken = AppDispatcher.register(storeAction(ObyPayStoreShared) as (payload: unknown) => void);

export default ObyPayStoreShared
export const store = ObyPayStore
export const action = storeAction